var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4542_2326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4542_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9462 12.0005L8.87309 7.92737C8.73462 7.78892 8.66379 7.61489 8.66059 7.40527C8.65737 7.19568 8.7282 7.01844 8.87309 6.87357C9.01795 6.72869 9.19359 6.65625 9.39999 6.65625C9.60639 6.65625 9.78202 6.72869 9.92689 6.87357L14.4211 11.3678C14.5147 11.4614 14.5807 11.5601 14.6192 11.6639C14.6577 11.7678 14.6769 11.88 14.6769 12.0005C14.6769 12.121 14.6577 12.2332 14.6192 12.337C14.5807 12.4408 14.5147 12.5396 14.4211 12.6331L9.92689 17.1274C9.78844 17.2658 9.6144 17.3367 9.40479 17.3399C9.19519 17.3431 9.01795 17.2723 8.87309 17.1274C8.7282 16.9825 8.65576 16.8069 8.65576 16.6005C8.65576 16.3941 8.7282 16.2184 8.87309 16.0736L12.9462 12.0005Z",
    fill: "#35353A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.8bb374851441ccc39f463ce6e25113f5.svg";
export { ForwardRef as ReactComponent };